import { faCheck } from "@fullscript/pro-solid-svg-icons";
import type { ReactNode, JSX } from "react";
import { isValidElement, Children } from "react";

import { CircularIcon, type CircularIconAviarySize } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./CheckmarkList.styles";

interface Props {
  circled?: boolean;
  size?: CircularIconAviarySize;
  children: ReactNode;
}

const CheckmarkList = ({ children, circled, size = "small" }: Props) => {
  const listItems = () =>
    Children.map(children, (child, index) => {
      if (!isValidElement(child)) {
        return null;
      }
      const { children: liChildren, css: liCss, ...otherProps } = (child as JSX.Element).props;

      const renderIcon = () => {
        if (circled) {
          return <CircularIcon icon={faCheck} size={size} css={styles.circleIcon} />;
        }

        return <FontAwesomeIcon icon={faCheck} css={styles.icon} />;
      };

      return (
        <li key={`checkmark-list-item-${index}`} css={[styles.listItem, liCss]} {...otherProps}>
          {renderIcon()}
          {liChildren}
        </li>
      );
    });

  return <ul css={styles.list}>{listItems()}</ul>;
};

export { CheckmarkList };
